<template>
  <section class="kq-detail" :aria-busy="loading">
    <div class="kq-title">原始签约信息</div>
    <div v-if="loading" class="kq-hint" role="status">详情查询中...</div>
    <div v-else-if="error" class="kq-error" role="alert">
      <span>详情查询失败：{{ error }}</span>
      <button v-if="externalAgreementNo" type="button" class="kq-retry" @click="loadDetail">重试</button>
    </div>
    <template v-else-if="detail">
      <dl class="kq-fields kq-summary">
        <div>
          <dt>签约状态</dt>
          <dd>
            <span class="kq-status" :class="detail.pciInfos.length ? 'kq-status-green' : 'kq-status-gray'">
              {{ detail.pciInfos.length ? '已签约' : '已解约或未签约' }}
            </span>
          </dd>
        </div>
        <div><dt>商户号</dt><dd class="kq-mono">{{ detail.merchantId || '-' }}</dd></div>
        <div><dt>终端号</dt><dd class="kq-mono">{{ detail.terminalId || '-' }}</dd></div>
        <div><dt>客户号</dt><dd class="kq-mono">{{ detail.customerId || '-' }}</dd></div>
        <div><dt>应答码</dt><dd>{{ detail.bizResponseCode }}</dd></div>
        <div><dt>应答信息</dt><dd>{{ detail.bizResponseMessage || '-' }}</dd></div>
      </dl>
      <div
        v-for="(card, index) in detail.pciInfos"
        :key="card.payToken || index"
        class="kq-card"
      >
        <div class="kq-card-title">交易卡 {{ index + 1 }}</div>
        <dl class="kq-fields">
          <div><dt>卡类型</dt><dd>{{ cardTypeText(card.cardType) }}</dd></div>
          <div><dt>缩略卡号</dt><dd class="kq-mono">{{ card.storablePan || '-' }}</dd></div>
          <div><dt>支付协议号</dt><dd class="kq-mono">{{ card.payToken || '-' }}</dd></div>
          <div><dt>银行代码</dt><dd>{{ card.bankId || '-' }}</dd></div>
          <div><dt>手机号</dt><dd>{{ card.phoneNo || '-' }}</dd></div>
          <div><dt>缩略手机号</dt><dd>{{ card.shortPhoneNo || card.shortphoneNo || '-' }}</dd></div>
        </dl>
      </div>
    </template>
  </section>
</template>

<script>
import { getKqAgreementStatus } from "@/utils/userQueryApi";
import { parseKqAgreementStatus } from "@/utils/kqAgreement";

export default {
  name: "KqAgreementDetails",
  props: {
    externalAgreementNo: { type: [String, Number], default: "" },
  },
  data() {
    return { loading: false, error: "", detail: null, requestId: 0 };
  },
  watch: {
    externalAgreementNo: {
      immediate: true,
      handler() {
        this.loadDetail();
      },
    },
  },
  beforeUnmount() {
    this.requestId += 1;
  },
  methods: {
    async loadDetail() {
      const requestId = ++this.requestId;
      const agreementNo = String(this.externalAgreementNo ?? "").trim();
      this.detail = null;
      this.error = "";
      this.loading = false;
      if (!agreementNo) {
        this.error = "缺少签约编号";
        return;
      }
      this.loading = true;
      try {
        const response = await getKqAgreementStatus(agreementNo);
        if (requestId !== this.requestId) return;
        this.detail = parseKqAgreementStatus(response);
      } catch (error) {
        if (requestId !== this.requestId) return;
        this.error = error?.message || "网络异常，请稍后重试";
      } finally {
        if (requestId === this.requestId) this.loading = false;
      }
    },
    cardTypeText(type) {
      if (!type) return "信用卡";
      return { "0001": "信用卡", "0002": "借记卡" }[type] || type;
    },
  },
};
</script>

<style scoped>
.kq-detail {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e8e5e0;
  font-size: 13px;
  color: #37352f;
}
.kq-title {
  margin-bottom: 8px;
  font-weight: 600;
}
.kq-hint {
  padding: 8px 0;
  color: #6b6966;
}
.kq-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
  gap: 8px 20px;
  margin: 0;
}
.kq-fields > div {
  display: flex;
  align-items: baseline;
  min-width: 0;
}
.kq-fields dt {
  flex: 0 0 80px;
  color: #6b6966;
}
.kq-fields dd {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}
.kq-summary {
  margin-bottom: 12px;
}
.kq-card {
  margin-top: 8px;
  padding: 12px;
  border: 1px solid #e8e5e0;
  border-radius: 4px;
  background: #f8f7f5;
}
.kq-card-title {
  margin-bottom: 12px;
  font-weight: 500;
}
.kq-mono {
  font-family: "SFMono-Regular", Menlo, Consolas, monospace;
  font-size: 12px;
}
.kq-status {
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}
.kq-status-green { background: #dbeddb; color: #2d6a2e; }
.kq-status-gray { background: #e8e5e0; color: #6b6966; }
.kq-error {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  color: #a63a32;
}
.kq-retry {
  padding: 4px 12px;
  border: 1px solid #d0ccc5;
  border-radius: 4px;
  background: #fff;
  color: #37352f;
  font: inherit;
  cursor: pointer;
}
.kq-retry:hover { background: #f0efed; }
.kq-retry:focus-visible { outline: 2px solid #2878b5; outline-offset: 2px; }
</style>
